import PropTypes from 'prop-types';

function IFDeliActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11293)">
                <path
                    d="M2.68931 18.3162C2.68931 18.3162 2.23669 18.5802 2.31213 19.4779C2.41774 20.7717 3.44368 20.1267 5.11837 20.1757L26.8668 18.2898C26.8668 18.2898 29.1713 18.2559 29.1298 17.3016C29.0884 16.3473 27.9568 16.5472 27.9568 16.5472L2.68931 18.3162Z"
                    fill="#D9291F"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.63599 20.3037C3.6737 20.7337 3.80572 23.1062 4.9599 23.9435C6.11408 24.7808 8.94673 24.1095 13.3937 23.7247C17.8407 23.34 25.4636 22.9704 26.4518 22.7026C26.9389 22.5793 27.3735 22.3027 27.6914 21.9135C28.0092 21.5243 28.1935 21.0432 28.217 20.5413C28.2303 19.7581 28.162 18.9756 28.0133 18.2065L3.63599 20.3037Z"
                    fill="#F6A685"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.64404 15.9888C2.64404 15.9888 1.60301 19.0478 3.25885 18.9346C7.46067 18.6442 13.1901 17.6484 15.3702 17.8219C17.5503 17.9954 17.9577 20.2849 19.3118 21.1638C20.8733 22.1784 21.737 20.5226 22.631 17.3919C23.027 16.1321 25.7842 17.0864 27.9379 16.5508C29.6466 16.1397 29.9332 14.9591 28.945 13.9596C28.1906 13.2052 23.7399 12.6432 14.9251 13.4353C6.11035 14.2274 2.64404 15.9888 2.64404 15.9888Z"
                    fill="#F7D46D"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.09303 13.922C3.09303 13.922 1.35799 13.922 0.931768 15.227C0.44143 16.7131 2.45936 17.4901 4.32642 17.3279C5.37697 17.2845 6.3951 16.9516 7.26844 16.3661C7.77281 15.9934 8.19948 15.5257 8.52446 14.9894C8.52446 14.9894 9.03366 16.7433 12.0172 16.5924C13.6013 16.517 14.6914 15.9361 15.442 14.3972C16.3925 15.8305 17.8409 16.3284 19.6212 15.9927C21.179 15.7023 22.2992 13.888 22.2992 13.888C23.2588 14.5781 24.3607 15.0446 25.5241 15.2534C27.278 15.525 30.6274 15.6117 30.1974 13.3486C29.6279 11.8399 27.2327 12.0247 27.2327 12.0247L3.09303 13.922Z"
                    fill="#C5DB66"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.09308 13.922C3.05536 12.6961 2.47827 9.35053 5.65415 8.50187C8.83003 7.65321 17.4675 7.26848 20.3303 6.93656C23.1932 6.60464 25.7769 7.29111 26.584 9.12045C27.3912 10.9498 27.2328 12.0248 27.2328 12.0248L3.09308 13.922Z"
                    fill="#F6A685"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.94634 7.82289C9.94634 7.82289 7.61912 9.84836 9.39565 11.7418C9.7502 10.267 10.2556 8.56594 12.6243 7.56641C11.0779 7.77009 9.94634 7.82289 9.94634 7.82289Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.2086 7.45336C14.2086 7.45336 11.8814 9.48261 13.6542 11.3761C14.0087 9.90128 14.5142 8.23413 16.8829 7.22705L14.2086 7.45336Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1992 7.13665C18.1992 7.13665 16.0229 9.1244 17.8032 11.0179C18.1578 9.54308 18.4708 7.92873 20.8207 6.9292C19.2742 7.04613 18.1992 7.13665 18.1992 7.13665Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11293">
                    <rect width="30" height="30" fill="white" transform="translate(0.545898 0.600586)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFDeliActive;

IFDeliActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFDeliActive.defaultProps = {
    className: null,
};
